import { takeEvery, put, call, select } from 'redux-saga/effects';
import { getProductOptionNew } from '../../../../services/product/option';
import { NewOptionActionTypes } from '../../../types/product/new-option';
import {
  getProductNewOptionRequestFailure,
  getProductNewOptionRequestSuccess,
} from '../../../actions/product/new-option';
import { getModifiersFilterContext } from '../../../../helpers/menuVisibility';

function* asyncProductOptionsRequest(action: any): any {
  try {
    const { id, selectedIds, chainProductId } = action;
    const { restaurant, rcData }: { restaurant: any; rcData: unknown } =
      yield select((state: any) => ({
        restaurant: state.restaurantInfoReducer.restaurant,
        rcData: state.menuManagementRemoteConfigReducer.data,
      }));
    const extref =
      restaurant?.extref != null && restaurant.extref !== ''
        ? String(restaurant.extref)
        : '';
    const filterCtx = getModifiersFilterContext(rcData, extref, chainProductId);

    const response = yield call(
      getProductOptionNew,
      id,
      selectedIds,
      filterCtx,
    );
    yield put(getProductNewOptionRequestSuccess(response));
  } catch (error) {
    yield put(getProductNewOptionRequestFailure(error));
  }
}

export function* productNewOptionsSaga() {
  yield takeEvery(
    NewOptionActionTypes.PRODUCT_NEW_OPTION_REQUEST,
    asyncProductOptionsRequest,
  );
}
